import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Col,
  Row,
  Breadcrumb,
  message,
  Form,
  Input,
  Alert,
  TimePicker,
  Spin,
  Typography,
  Card,
  Tabs,
} from "antd";
import ProtocolServices from "../../../services/ProtocolServices";
import { useParams, Link } from "react-router-dom";
import { ProtocolProvider } from "../../../providers/ProtocolContext";
import ProtocolsActionDaysTable from "../../../components/Tables/ProtocolsActionDaysTable";
import ProtocolAssociatedCoTable from "../../../components/Tables/ProtocolAssociatedCoTable";
import AddProtocolDay from "../../../components/Modals/AddProtocolDay";
import SimpleReactValidator from "simple-react-validator";
import { translate } from "../../../locale";
import { LoadingOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import AssociateEntreprise from "../../../components/Modals/AssociateEntreprise";
import AddAppointment from "../../../components/Modals/AddAppointment";
import ProtocolsActionTurnsTable from "../../../components/Tables/ProtocolsActionTurnsTable";
import { SimpleReactValidatorHelper } from "../../../helpers/SimpleReactValidatorHelper";

const { Title } = Typography;

const ProtocolDetails = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [showModalEnterprise, setShowModalEnterprise] = useState(false);
  const [modalVisible, setModalVisible] = useState({
    add: false,
    edit: false,
    addCondition: false,
  });
  const [reloadTable, setReloadTable] = useState(0);
  const [protocol, setProtocol] = useState(null);
  const [enterpricesIds, setEnterpricesIds] = useState(null);
  const [values, setValues] = useState({
    name: "",
    dispatch_time: dayjs("1970-01-01 12:00", "HH:mm"),
  });
  const [, forceUpdate] = useState();
  const [showModalAddAppointment, setShowModalAddAppointment] = useState(false);
  const disabled = () => !simpleValidator.current.allValid();
  const [totalDays, setTotalDays] = useState(0);
  const [totalTurns, setTotalTurns] = useState(0);

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: SimpleReactValidatorHelper.elementMessage,
      messages: {
        required: "Campo requerido",
      },
    })
  );

  useEffect(() => {
    loadProtocol();
  }, []);

  const loadProtocol = async () => {
    setLoading(true);
    try {
      const res = await ProtocolServices.getProtocol(id);
      if (res.status >= 200 && res.status < 300) {
        setProtocol(res.data.protocols);
        if (res.data.protocols?.enterprises_info) {
          const ids = res.data.protocols.enterprises_info
            .map((i) => i.id)
            .filter((i) => i !== null);
          setEnterpricesIds(ids === null ? [] : ids);
        }
        setValues((v) => ({
          ...v,
          ...res.data.protocols,
          dispatch_time: dayjs(
            `1970-01-01 ${
              res.data.protocols.dispatch_time !== null
                ? res.data.protocols.dispatch_time
                : "12:00"
            }`,
            "HH:mm"
          ),
        }));
      } else {
        message.error(res.data.message);
      }
      setLoading(false);
    } catch (e) {
      message.error(e.message);
      setLoading(false);
    }
  };

  const handleModalCancel = (name) => {
    setModalVisible((v) => ({ ...v, [name]: false }));
  };
  const handleModalComplete = (name) => {
    // update user list
    setModalVisible((v) => ({ ...v, [name]: false }));
    setReloadTable((v) => v + 1);
  };

  const handleAddDay = () => {
    setModalVisible((v) => ({ ...v, add: true }));
  };

  const handleDelete = async (item) => {
    setLoading(true);
    try {
      const res = await ProtocolServices.deleteProtocolDetails(
        item.protocol,
        item.id
      );

      if (res.status >= 200 && res.status < 300) {
        message.success("El día del protocolo se eliminó exitosamente.");
      } else {
        message.error(res.data.message);
      }
      setReloadTable((v) => v + 1);
      setLoading(false);
    } catch (e) {
      message.error(e.message);
      setLoading(false);
    }
  };

  const handleDeleteCondition = async (item) => {
    setLoading(true);
    try {
      const res = await ProtocolServices.deleteProtocolCondition(item.id);

      if (res.status >= 200 && res.status < 300) {
        message.success("La condición se eliminó exitosamente.");
      } else {
        message.error(res.data.message);
      }
      setReloadTable((v) => v + 1);
      setLoading(false);
    } catch (e) {
      message.error(e.message);
      setLoading(false);
    }
  };

  const onFinish = async () => {
    setSaving(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError(translate("Todos los datos son requeridos"));
      return;
    }
    try {
      const response = await ProtocolServices.updateProtocol({
        id: values.id,
        name: values.name,
        dispatch_time: values.dispatch_time.format("HH:mm"),
      });
      if (response.status >= 200 && response.status < 300) {
        message.success(
          translate("El {0} se guardó exitosamente.", translate("protocolo"))
        );
        resetForm();
      } else {
        setError(response.data.message);
      }
      setSaving(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setSaving(false);
    }
  };

  const resetForm = () => {
    setError("");
    setValues({
      name: "",
      dispatch_time: dayjs("1970-01-01 12:00", "HH:mm"),
    });
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    forceUpdate();
  };

  const handleChange = (name, value) => {
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleAsociateEnterprise = () => {
    setShowModalEnterprise(true);
  };

  const handleEnterpriseComplete = (enterprise_id) => {
    setReloadTable((v) => v + 1);
    setEnterpricesIds((v) => [...v, enterprise_id]);
    setShowModalEnterprise(false);
    loadProtocol();
  };

  const handleEnterpriseCancel = () => {
    setShowModalEnterprise(false);
  };

  const getTotalDays = () => {
    return totalDays > 0 ? ` (${totalDays})` : "";
  };

  const getTotalTurns = () => {
    return totalTurns > 0 ? ` (${totalTurns})` : "";
  };

  const tabItems = [
    {
      label: `${translate("Días")}${getTotalDays()}`,
      key: "day",
      forceRender: true,
      children: (
        <>
          <div className="text-end mb-8">
            <Button
              type="primary"
              className="bg-custom_primary border-custom_primary ml-4"
              onClick={handleAddDay}
            >
              {translate("Agregar acción")}
            </Button>
          </div>
          <ProtocolsActionDaysTable
            id={parseInt(id)}
            reload={reloadTable}
            onChange={(total) => setTotalDays(total)}
            onDelete={handleDelete}
            onDeleteCondition={handleDeleteCondition}
            loading={loading}
            enterprises={protocol?.enterprises_info.filter(
              (i) => i.id !== null
            )}
          />
        </>
      ),
    },
    protocol?.turnable
      ? {
          label: `${translate("Turnos")}${getTotalTurns()}`,
          key: "turn",
          forceRender: true,
          children: (
            <>
              <div className="text-end mb-8">
                <Button
                  type="primary"
                  className="bg-custom_primary border-custom_primary ml-4"
                  onClick={() => setShowModalAddAppointment(true)}
                >
                  {translate("Agregar acción en turno")}
                </Button>
              </div>
              <ProtocolsActionTurnsTable
                id={parseInt(id)}
                reload={reloadTable}
                onChange={(total) => setTotalTurns(total)}
                onDelete={handleDelete}
                onDeleteCondition={handleDeleteCondition}
                loading={loading}
                enterprises={protocol?.enterprises_info.filter(
                  (i) => i.id !== null
                )}
              />
            </>
          ),
        }
      : null,
  ];

  return (
    <ProtocolProvider>
      <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
        <Row gutter={16}>
          <Col className="gutter-row" span="12">
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to="/admin">{translate("Inicio")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/admin/protocols">{translate("Protocolos")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {protocol !== null
                  ? protocol.name
                  : translate("Detalle de protocolo")}
              </Breadcrumb.Item>
            </Breadcrumb>
          </Col>

          <Col span="24" className="my-4">
            <Title level={2} className="text-center">
              {translate("Protocolo")}
            </Title>
          </Col>
          <Col span="24" className="gutter-row mt-2 mb-6">
            <Card>
              {error && (
                <Alert
                  message={error}
                  type="error"
                  className="mb-6"
                  closable
                  onClose={() => setError("")}
                />
              )}
              <Form
                initialValues={{ remember: true }}
                onFinish={onFinish}
                autoComplete="off"
                className="flex flex-col items-start"
                layout="vertical"
              >
                <Form.Item label={translate("Nombre")}>
                  <Input
                    placeholder={translate("Nombre")}
                    className="border-custom_primary"
                    name="name"
                    onChange={(e) => handleChange("name", e.target.value)}
                    value={values.name}
                  />
                  {simpleValidator.current.message(
                    "name",
                    values.name,
                    "required"
                  )}
                </Form.Item>
                <Form.Item label={translate("Hora de envío")}>
                  <TimePicker
                    format="HH:mm"
                    placeholder="00:00"
                    className="border-custom_primary"
                    name="dispatch_time"
                    defaultValue={dayjs("1970-01-01 12:00", "HH:mm")}
                    onChange={(time, timeString) =>
                      handleChange("dispatch_time", time)
                    }
                    value={values.dispatch_time}
                    minuteStep={10}
                  />
                  {simpleValidator.current.message(
                    "dispatch_time",
                    values.dispatch_time !== null
                      ? values.dispatch_time.toString()
                      : "",
                    "required"
                  )}
                </Form.Item>
                <Form.Item>
                  <Row align="end" gutter={16}>
                    <Col>
                      <Button
                        key="back"
                        onClick={() => setValues({ dispatch_time: "" })}
                      >
                        {translate("Cancelar")}
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        disabled={disabled() || saving}
                        htmlType="submit"
                        type="primary"
                        className="bg-custom_primary"
                      >
                        {saving ? (
                          <Spin
                            indicator={
                              <LoadingOutlined style={{ color: "#666666" }} />
                            }
                          />
                        ) : (
                          translate("Guardar")
                        )}
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Form>
            </Card>
          </Col>

          <Col
            span="24"
            className="flex flex-row justify-center mt-6 mb-6 bg-gray-200"
          >
            <Title level={4} className="my-4">
              {translate("EMPRESAS")}
            </Title>
          </Col>

          <Col className="gutter-row" span="24">
            <div className="text-end">
              <Button
                type="primary"
                className="bg-custom_primary border-custom_primary"
                onClick={handleAsociateEnterprise}
              >
                {translate("Asociar empresa")}
              </Button>
              <AssociateEntreprise
                protocol={protocol}
                protocolEntrepriseIds={enterpricesIds}
                visible={showModalEnterprise}
                onComplete={handleEnterpriseComplete}
                onCancel={handleEnterpriseCancel}
              />
            </div>
          </Col>

          <Col span="24" className="mt-6 mb-12">
            <ProtocolAssociatedCoTable
              protocol={protocol}
              reload={reloadTable}
              onDelete={handleDelete}
              onDeleteCondition={handleDeleteCondition}
            />
          </Col>

          <Col
            span="24"
            className="flex flex-row justify-center mt-6 mb-6 bg-gray-200"
          >
            <Title level={4} className="my-4">
              {translate("ACCIONES")}
            </Title>
          </Col>
          <Col span="24" className="mt-6">
            <Tabs items={tabItems} />
          </Col>
        </Row>
      </div>

      <AddProtocolDay
        protocolId={id}
        visible={modalVisible.add}
        onCancel={() => {
          handleModalCancel("add");
        }}
        onComplete={() => {
          handleModalComplete("add");
        }}
      />
      <AddAppointment
        protocolId={id}
        visible={showModalAddAppointment}
        onCancel={() => {
          setShowModalAddAppointment(false);
        }}
        onComplete={() => {
          setShowModalAddAppointment(false);
          setReloadTable((v) => v + 1);
        }}
      />
    </ProtocolProvider>
  );
};

export default ProtocolDetails;
